import { render, staticRenderFns } from "./BoxContainer.vue?vue&type=template&id=30adbbe2&scoped=true"
import script from "./BoxContainer.vue?vue&type=script&lang=ts"
export * from "./BoxContainer.vue?vue&type=script&lang=ts"
import style0 from "./BoxContainer.scss?vue&type=style&index=0&id=30adbbe2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30adbbe2",
  null
  
)

export default component.exports